import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import HttpClient from "../utils/HttpClient";
import toast from 'react-hot-toast';

const AddMyProfileServiceModal = ({ closemodal, data, setData, updateForm, setSaveEditedData }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [services, setServices] = useState(data?.serviceName || []);
  const [servicesIds, setServicesIds] = useState(data?.serviceID || []);
  const [serviceOptions, setServiceOptions] = useState([])

  const submit = (e) => {
    e.preventDefault()
    const flatSelectedOptions = selectedOptions.map((item) => item.value)
    const flatSelectedOptionsName = selectedOptions.map((item) => item.label)
    const updatedServices = [...services, ...flatSelectedOptionsName];
    const updatedServicesIds = [...servicesIds, ...flatSelectedOptions];
    setServices(updatedServices);
    selectedOptions?.length > 0 && setData((prevData) => ({ ...prevData, "serviceName": updatedServices }));
    selectedOptions?.length > 0 && setData((prevData) => ({ ...prevData, "serviceID": updatedServicesIds }));
    setSelectedOptions([])
    setSaveEditedData(true);
    closemodal(false);
  };

  const getCompanyTypeWiseServices = async (id) => {
    try {
      // const res = await HttpClient.requestData(`service`, "GET");
      const res = await HttpClient.requestData(`companyType-wise-servicess/${id}`, "GET");
      if (res?.status) {
        const filteredData = res.data.filter((item) => !servicesIds.includes(item._id));
        setServiceOptions(filteredData.map((item) => ({
          value: item._id,
          label: item.name,
        })) || []);
      }
    } catch (error) {
      console.error("Error occured!", error);
    }
  };

  useEffect(() => {
    getCompanyTypeWiseServices(UserProfileID?.companyTypeID || data?.companyTypeID)
  }, [])

  const handleServiceChange = (selected) => {
    const newTotKeywords = services.length + selected.length;
    if (newTotKeywords > 5) {
      toast.error("Cannot add more services — limit reached")
    } else {
      setSelectedOptions(selected);
    }
  };

  return (
    <div className="edittamodalboixshadow">
      <div className="edittamodalboixsbg">
        <h5 className="mt-2 p-0 m-3">Add Services</h5>
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <hr />
        <div className="abattstdovvstttschgg">
          <Select
            options={serviceOptions}
            isMulti
            value={selectedOptions}
            onChange={handleServiceChange}
            placeholder="Select services..."
          />

          {selectedOptions?.length > 0 && (
            <div className="svavtatvvbtnnmpaggdijbtn">
              <button
                onClick={(e) => submit(e)}
                className="svavtatvvbtnnm">
                Save Selected
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddMyProfileServiceModal;